import React from 'react';
import {
  Modal,
  ModalDialog,
  Typography,
  Divider,
  Box,
  Button,
} from '@mui/joy';

export default function OrderDetailsModal({ open, onClose, order }) {
  if (!open || !order || typeof order.dati_json !== 'string') return null;

  let data;
  try {
    data = JSON.parse(order.dati_json);
  } catch {
    data = {};
  }

  const {
    pacchettoSelezionato,
    addon = [],
    scontoUpgrade,
    scontoMezzi,
    scontoManuale,
    scontoTotale,
    totaleNetto,
    deltaVeicoli,
  } = data;

  return (
    <Modal open={open} onClose={onClose}>
      <ModalDialog>
        <Typography level="h4" mb={1}>
          Dettagli Ordine #{order.id}
        </Typography>

        {pacchettoSelezionato ? (
          <Box mb={1}>
            <Typography level="body-sm" fontWeight="lg">Pacchetto:</Typography>
            <Typography>{pacchettoSelezionato.label} ({pacchettoSelezionato.price_amount} €)</Typography>
          </Box>
        ) : (
          <Typography>Nessun pacchetto selezionato</Typography>
        )}

        {addon[0].quantita > 0 && (
          <Box mb={1}>
            <Typography level="body-sm" fontWeight="lg">Addon:</Typography>
            <ul style={{ paddingLeft: 20 }}>
              {addon.map((a, i) => (
                <li key={i}>
                  Mezzi × {a.quantita} ({a.prezzoUnitario * a.quantita} €) = {a.prezzoUnitario * a.quantita} €
                </li>
              ))}
            </ul>
          </Box>
        )}

        <Divider sx={{ my: 1 }} />

        <Box>
          <Typography level="body-sm" fontWeight="lg">Sconti:</Typography>
          <Typography level="body-sm">- Upgrade: {scontoUpgrade} €</Typography>
          <Typography level="body-sm">- Mezzi: {scontoMezzi} €</Typography>
          <Typography level="body-sm">- Manuale: {scontoManuale} €</Typography>
          <Typography level="body-sm" fontWeight="lg">Totale sconto: {scontoTotale} €</Typography>
        </Box>

        <Box mt={1}>
          <Typography>Delta veicoli: {deltaVeicoli > 0 ? '+' : ''}{deltaVeicoli}</Typography>
        </Box>

        <Divider sx={{ my: 1 }} />

        <Typography fontWeight="lg">
          Totale netto: {parseFloat(totaleNetto || order.totale_netto).toFixed(2)} €
        </Typography>

        <Box mt={3} display="flex" justifyContent="flex-end">
          <Button variant="soft" onClick={onClose}>Chiudi</Button>
        </Box>
      </ModalDialog>
    </Modal>
  );
}
